import { render, staticRenderFns } from "./wechart-qrcode.vue?vue&type=template&id=dfc69bce&scoped=true&"
import script from "./wechart-qrcode.vue?vue&type=script&lang=js&"
export * from "./wechart-qrcode.vue?vue&type=script&lang=js&"
import style0 from "./wechart-qrcode.vue?vue&type=style&index=0&id=dfc69bce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc69bce",
  null
  
)

export default component.exports